<template>
  <custom-dialog
    width="500px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    :append-to-body="true"
  >
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$t('fms_body_item_dialog.ming_cheng')"
              prop="buyerName"
            >
              <el-input
                v-model.trim="form.buyerName"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$t('fms_body_item_dialog.shui_hao')"
              prop="buyerNumber"
            >
              <el-input
                v-model.trim="form.buyerNumber"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$t('fms_body_item_dialog.dan_wei_di_zhi')"
              prop="buyerRegisterAddress"
            >
              <el-input
                v-model.trim="form.buyerRegisterAddress"
                type="textarea"
                :rows="2"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$t('fms_body_item_dialog.dian_hua_hao_ma')"
              prop="buyerMobile"
            >
              <el-input
                v-model.trim="form.buyerMobile"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$t('fms_body_item_dialog.kai_hu_yin_hang')"
              prop="buyerDepositBank"
            >
              <el-input
                v-model.trim="form.buyerDepositBank"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$t('fms_body_item_dialog.yin_hang_zhang_hu')"
              prop="buyerDepositNumber"
            >
              <el-input
                v-model.trim="form.buyerDepositNumber"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$t('fms_body_item_dialog.you_xiang')"
              prop="buyerEmail"
            >
              <el-input
                v-model.trim="form.buyerEmail"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="visible = false">{{$t('Common.com_cancel')}}</el-button>
      <el-button
        type="primary"
        @click="saveGroup"
      >{{$t('Common.com_confirm')}}</el-button>
    </div>
  </custom-dialog>
</template>
<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],

  props: {
    showEmail: {
      type: Boolean,
      default: false
    },
    partnerOrgId: String
  },

  data() {
    return {
      form: {
        buyerDepositBank: '', // 买方银行卡开户支行
        buyerDepositNumber: '', // 买方银行账号
        buyerMobile: '', // 买方电话号码
        buyerName: '', // 买方名称（发票抬头）
        buyerNumber: '', // 买方纳税人识别号
        buyerRegisterAddress: '', // 买方注册地址
        partnerInvoiceId: null, // 主体id [编辑时不为空]
        buyerEmail: '',
        partnerOrgId: null
      },

      editOff: false,
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        buyerNumber: {
          required: true,
          message: this.$t('Common.com_required')
        },
        buyerName: {
          required: true,
          message: this.$t('Common.com_required')
        },
        buyerMobile: [{
          required: true,
          message: this.$t('Common.com_required')
        },
        {
          validator: null,
          message: this.$t('Common.com_required')
        }],

        buyerDepositNumber: {
          required: true,
          message: this.$t('Common.com_required')
        },

        buyerDepositBank: {
          required: true,
          message: this.$t('Common.com_required')
        },
        buyerRegisterAddress: {
          required: true,
          message: this.$t('Common.com_required')
        },
        buyerEmail: [
          {
            type: 'email',
            message: this.$t('Common.com_required'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) }
        ]
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.partnerOrgId) {
        this.form.partnerOrgId = this.partnerOrgId;
      }
      if (this.model.type === 'add') {
        this.editOff = false;
      }
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.data);
        this.pushConfId = this.model.data.pushConfId;
        // 编辑 disabled
        this.editOff = true;
      }
      this.rules.buyerMobile[1].validator = this.$mobilePhoneValidator;
    },

    // 确认保存分组
    saveGroup: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        if (this.model.type === 'add') {
          this.saveAddItem();
        }
        if (this.model.type === 'edit') {
          this.saveEditItem();
        }
      });
    },
    // 保存新增分组
    saveAddItem: function () {
      this.$postJSON(apis.crmPartnerInvoiceAdd, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success'
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    saveEditItem: function () {
      this.$postJSON(apis.crmPartnerInvoiceUpdate, this.form, true).then(() => {
        if (this.model.type === 'add') {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success'
          });
        } else if (this.model.type === 'edit') {
          this.$message({
            message: this.$t('Common.com_edit_success'),
            type: 'success'
          });
        }
        this.$emit('success');
        this.visible = false;
      });
    }
  }
};
</script>

<style lang="scss">
</style>
